/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type DecisionContingencyCheckbox_ItemFragment = { __typename: 'Item', id: string, decisionContingentItemPreselection?: boolean | null };

export const DecisionContingencyCheckbox_ItemFragmentDoc = gql`
    fragment DecisionContingencyCheckbox_Item on Item {
  id
  decisionContingentItemPreselection
}
    `;